(section_name=>{
// provide js within this function or remove the entire file if it's not needed
function waitUntil(predicate, time = 10000) {
    return new Promise(((resolve) => {
        let int = setInterval(() => {
            if (predicate()) {
                resolve(predicate());
                clearInterval(int);
                int = null;
            }
        }, 500);
        setTimeout(() => {
            if (int !== null) {
                clearInterval(int);
                console.log('condition false');
            }
        }, time);
    }));
}

waitUntil(() => typeof Swiper === 'function' && document.querySelector('.acc_bf_lp_02_review_section_items.swiper') !== null).then(() => {
    const reviewContainer = document.querySelector('.acc_bf_lp_02_review_section_items.swiper');
        new Swiper(reviewContainer, {
            slidesPerView: "auto",
            spaceBetween: 16,
            watchOverflow: true,
            pagination: {
                el: reviewContainer.querySelector(".acc_bf_lp_02_review_pagination"),
                clickable: true,
            },
        });
});

const offerButtons = document.querySelectorAll('.acc_bf_lp_02_01_button');
const shopSection = document.querySelector('.acc_bf_lp_02_shop_section_wrapper');
const shopSectionOffset = 76;

if (shopSection) {
    offerButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const shopSectionTop = shopSection.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
                behavior: 'smooth',
                top: shopSectionTop - shopSectionOffset,
            });
        });
    });
}

})("acc_bf_lp_02_01");
